module.exports = __webpack_public_path__ + "img/45.596b26e3.svg";